<style lang="scss" scoped>
.blue {
  color: #173bcf;
  position: relative;
  &:nth-child(n + 2) {
    margin-left: 10px;
  }
  &:nth-child(n + 2)::after {
    content: '';
    position: absolute;
    left: -5px;
    top: 2px;
    width: 1px;
    height: 17px;
    background: #173bcf;
    cursor: default;
  }
}
.table {
  background: #fff;
  height: 400px;
  margin-top: 20px;
  position: relative;
}
.kong {
  color: #606266;
  i {
    font-size: 150px;
    color: #bdc7db;
  }
}
.color1 {
  color: #00a8e1;
}
.color2 {
  color: #e02020;
}
.color3 {
  color: #17cfb8;
}
.color4 {
  color: #9a9a9a;
}
.black {
  color: #000;
}
.gray {
  color: #606266;
}
.block {
  padding: 0 70px;
  .input {
    width: 100%;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    display: flex;
    padding: 0 10px;
    height: 40px;
    margin: 10px 0;
  }
  .tags {
    float: left;
    display: flex;
    height: 24px;
    margin-top: 8px;
    > span:nth-child(n + 2) {
      margin-left: 5px;
    }
  }
  /deep/ .el-input__inner {
    border: transparent;
  }
}
/deep/ .el-table th {
  background: #fff;
}
</style>

<template>
  <div>
    <AlertTips />
    <div class="clearfix">
      <router-link to="index/creat">
        <el-button class="fl" type="primary" icon="el-icon-plus">新建群发任务</el-button>
      </router-link>
      <div class="fr">
        <el-date-picker
          v-model="value"
          type="daterange"
          align="right"
          unlink-panels
          format="dd/MM/yyyy"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeDate"
          :picker-options="rang"
        ></el-date-picker>
        <el-button type="primary" class="ml30">查询</el-button>
      </div>
    </div>
    <div class="table">
      <template v-if="tableData.length">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="群发主题"></el-table-column>
          <el-table-column label="发送对象">
            <template slot-scope="scope">
              <div>{{scope.row.type == 1 ? '所有粉丝' : '分组粉丝'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="new" label="信息类型">
            <template slot-scope="scope">
              <div v-if="scope.row.replyType == 1">文本</div>
              <div v-else-if="scope.row.replyType == 2">图片</div>
              <div v-else-if="scope.row.replyType == 3">图文</div>
              <div v-else-if="scope.row.replyType == 4">语音</div>
              <div v-else-if="scope.row.replyType == 5">视频</div>
              <div v-else-if="scope.row.replyType == 10">外链</div>
            </template>
          </el-table-column>
          <el-table-column label="任务状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 1" class="color1">待处理</div>
              <div v-else-if="scope.row.status == 2" class="color1">处理中...</div>
              <div v-else-if="scope.row.status == 3" class="color2">等待中</div>
              <div v-else-if="scope.row.status == 4" class="color2">处理失败</div>
              <div v-else-if="scope.row.status == 5" class="color3">待发送</div>
              <div v-else-if="scope.row.status == 6" class="color3">发送中...</div>
              <div v-else-if="scope.row.status == 7" class="color4">已发送</div>
              <div v-else-if="scope.row.status == 8" class="color2">发送失败</div>
            </template>
          </el-table-column>
          <el-table-column label="群发日期/时间">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 4"></div>
              <router-link
                v-else-if="scope.row.status == 3"
                :to="{path:'index/edit',query:{gmid: scope.row.groupMessageId}}"
              >
                <div class="color2 pointer">设置发送时间</div>
              </router-link>
              <div v-else>{{momentutc(scope.row.pushDate)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span
                class="blue pointer"
                v-show="scope.row.status != 4"
                @click="preview(scope.row.groupMessageId)"
              >预览</span>
              <span
                class="blue pointer"
                v-show="scope.row.status == 4"
                @click="resubmit(scope.row.groupMessageId)"
              >重新提交</span>
              <span
                class="blue"
                v-show="scope.row.status != 3 && scope.row.status != 6 && scope.row.status != 7 &&scope.row.status != 8"
              >
                <router-link :to="{path:'index/edit',query:{gmid: scope.row.groupMessageId}}">修改</router-link>
              </span>
              <span
                class="blue pointer"
                v-show="scope.row.status != 6 && scope.row.status != 7 && scope.row.status != 8"
                @click="del(scope.row.groupMessageId)"
              >删除</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-else>
        <div class="kong center">
          <div class="alignc">
            <i class="iconfont iconkong"></i>
          </div>
          <div>还没有创建群发任务哦</div>
        </div>
      </template>
    </div>
    <div class="mt30 alignc">
      <el-pagination
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="page"
        :total="total"
        hide-on-single-page
        @current-change="changePage"
      ></el-pagination>
    </div>
    <el-dialog title="发送预览" :visible.sync="dialogVisible" width="778px" :before-close="handleClose">
      <div class="block">
        <p class="black">关注公众还后，才能接收图文消息预览</p>
        <div class="input">
          <div class="tags">
            <el-tag
              v-for="(tag,index) in tags"
              :key="index"
              closable
              type="info"
              @close="handleClose(tag)"
              size="small"
            >{{tag}}</el-tag>
          </div>
          <el-input
            v-show="tags.length < 3"
            v-model="wechat"
            placeholder="可输入最多三个微信号，按回车分隔"
            @keyup.enter.native="addTag"
          ></el-input>
        </div>
        <p>预览功能仅用于公众号查看文章效果，不适用于公众传播，预览链接会在短期内失效</p>
        <div class="mt30 alignc">
          <el-button type="primary" @click="submitPre">发 送</el-button>
          <el-button type="info" @click="dialogVisible = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AlertTips from '@/components/alertTips';
export default {
  components: {
    AlertTips,
  },
  computed: {},
  props: ['id'],
  data() {
    return {
      tableData: [],
      value: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      wechat: '',
      tags: [],
      rang: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  async mounted() {
    await this.getData();
    console.log(this.moment(1561600800000));
  },
  methods: {
    async changePage(val) {
      this.page = val;
      await this.getData();
    },
    async changeDate() {
      await this.getData();
    },
    async getData() {
      let res;
      if (this.value.length) {
        res = await this.$http.get(
          `/api/${this.id}/group-messages?page=${this.page}&size=${
            this.pageSize
          }&begin=${this.moment(this.value[0])}&end=${this.moment(
            this.value[1],
          )}`,
        );
      } else {
        res = await this.$http.get(
          `/api/${this.id}/group-messages?page=${this.page}&size=${this.pageSize}`,
        );
      }
      console.log(res);
      this.tableData = res.list;
      this.total = res.totalSize;
    },
    preview(id) {
      this.dialogVisible = true;
      this.previewId = id;
    },
    addTag() {
      this.tags.push(this.wechat);
      this.wechat = '';
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
    },
    async submitPre() {
      if (!this.tags.length && !this.wechat) {
        this.$message.error('请填写微信号');
        return;
      } else if (!this.tags.length) {
        this.tags.push(this.wechat);
        this.wechat = '';
      }
      let res = await this.$http.post(
        `/api/${this.id}/group-message/${this.previewId}/preview`,
        this.tags,
      );
      this.dialogVisible = false;
    },
    async del(id) {
      let res = await this.$confirm('确认删除该群发消息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      if (res) {
        await this.$http.delete(`/api/${this.id}/group-message/${id}`);
        this.$message.success('删除成功');
        this.getData();
      }
    },
    async resubmit(id) {
      let res = this.$http.get(`/api/${this.id}/group-message/${id}/rehash`);
      console.log(res);
      this.getData();
    },
  },
};
</script>
